module.exports = __webpack_public_path__ + "media/audio84.51f5184c.mp3";